module.exports = __webpack_public_path__ + "img/right-arrow.7adbe5a9.svg";